import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import SearchIcon from "@material-ui/icons/Search";
import classes from "./SearchField.module.scss";

export default function SearchField({
  placeholder,
  width,
  margin,
  value,
  setValue,
}) {
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div className={classes.root} style={{ width: width, margin: margin }}>
      <FormControl variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          endAdornment={
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </FormControl>
    </div>
  );
}
